import axios from 'axios';
import { store } from '../store';

// `site.com?preview` will load the unpublished preview site theme.
const preview = new URLSearchParams(window.location.search).has('preview');

/**
 * Pull down the latest published theme.
 */
export const loadTheme = (hash) => {
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/theme/`,
    params: { hash },
  }).then(({ data }) => {
    store.dispatch({ type: 'LOAD_THEME', payload: { ...data } });
  });
};

/**
 * Check for any published theme updates.
 */
export const validateTheme = () => {
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/theme/versions/`,
  }).then(({ data }) => {
    const current = store.getState().theme.hash;
    const hash = preview ? data.draft : data.live;

    if (hash !== current) {
      loadTheme(hash);
    }
  });
};
